export type BackgroundJobStatusType = {
  id: string;
  jobId: string;
  jobClassName: string;
  status: keyof typeof BackgroundJobStatusStatus;
  statusHumanName: keyof typeof BackgroundJobStatusStatusHumanName;
  finishedAt?: string;
  errorMessage?: string;
  backtrace?: string;
  createdAt: string;
  updatedAt: string;
};

export const BackgroundJobStatusStatus = {
  running: "running",
  success: "success",
  failure: "failure",
} as const;

const BackgroundJobStatusStatusHumanName = {
  [BackgroundJobStatusStatus.running]: "実行中",
  [BackgroundJobStatusStatus.success]: "成功",
  [BackgroundJobStatusStatus.failure]: "失敗",
} as const;
